import { useMemo } from "react";
import { Link } from "react-router-dom";
import { ArrowDownUp, Trash2 } from "lucide-react";

interface ColumnsProps {
  onClickDelete: (data: any) => void;
  onClickUpdate: (data: any) => void;
  onclickSort: (data: any) => void;
}

const FegisterBazeFactoryColumns = ({
  onClickDelete,
  onClickUpdate,
  onclickSort,
}: ColumnsProps) => {
  const FegisterBazeFactoryColumns = useMemo(
    () => [
      {
        header: "سال زارع",
        accessorKey: "crop_year_name",
        enableColumnFilter: false,
      },
      {
        header: "نام بذر",
        accessorKey: "seed_name",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },
      {
        header: "نام کارخانه",
        accessorKey: "factory_name",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },
      {
        header: () => (
          <span className="flex" onClick={() => onclickSort("farmer_price")}>
            قیمت کشاورز{" "}
            <span className="text-blue-600 text-[10px]">(ریال)</span>
            <ArrowDownUp size={15} className="text-gray-500 gap-2" />
          </span>
        ),

        accessorKey: "farmer_price",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },
      {
        header: () => (
          <span className="flex" onClick={() => onclickSort("factory_price")}>
            قیمت کارخانه{" "}
            <span className="text-blue-600 text-[10px]">(ریال)</span>
            <ArrowDownUp size={15} className="text-gray-500 gap-2" />
          </span>
        ),

        accessorKey: "factory_price",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },

      {
        header: () => (
          <span className="flex" onClick={() => onclickSort("amount")}>
            مقدار
            <ArrowDownUp size={15} className="text-gray-500 gap-2" />
          </span>
        ),
        accessorKey: "amount",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },

      {
        header: "نام واحد",
        accessorKey: "unit_name",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },

      {
        header: "تاریخ ایجاد",
        accessorKey: "created_at",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <Link
            to="#"
            className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
          >
            {cell.getValue()}
          </Link>
        ),
      },
      {
        header: "عملیات",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell: any) => (
          <div className="flex gap-3">
            <Link to="#" onClick={() => onClickDelete(cell.row.original)}>
              <span className="rounded p-2 w-20 ml-3 bg-red-800 text-white">
                حذف
              </span>
            </Link>
            <Link to="#" onClick={() => onClickUpdate(cell.row.original)}>
              <span className="rounded p-2 w-20 ml-3 bg-green-800 text-white">
                ویرایش
              </span>
            </Link>
          </div>
        ),
      },
    ],
    []
  );

  return FegisterBazeFactoryColumns;
};

export default FegisterBazeFactoryColumns;
